// import { useState,useEffect } from "react";
// import GridCheckbox from "../ui/checkbox/GridCheckbox";

// // Function for rendering the checkbox column
// const RenderGridCheckboxColumn = ({
//   rowData,
//   col,
//   rowIndex,
//   onColumnDataChange,
//   headerCheckboxState,
//   fieldName,
//   handleRowClick,
// }) => {
//   const [value, setValue] = useState(rowData[col.fieldName]);
//   const { colSettings, fieldName } = col;
//   const isDisabled = typeof col.colSettings?.isDisabled === 'function'
//   ? col.colSettings.isDisabled(rowData)
//   : col.colSettings?.isDisabled;


//     useEffect(() => {
//     setValue(rowData[fieldName]);
//   }, [rowData, fieldName]);

//   const handleCheckboxChange = (e) => {
//     const newValue = !value;
//     setValue(newValue);

//     if (onColumnDataChange) {
//       const newRowData = { ...rowData, [fieldName]: newValue };
//       onColumnDataChange(fieldName, newRowData, rowIndex);
//     }
//   };

//   return (
//     <GridCheckbox
//       type="checkbox"
//       checked={value}
//       disabled={isDisabled}
//       onChange={(handleCheckboxChange)}
//     />
//   );
// };


// export default RenderGridCheckboxColumn

import { useState, useEffect } from "react";
import GridCheckbox from "../ui/checkbox/GridCheckbox";
import PropTypes from "prop-types";

const RenderGridCheckboxColumn = ({
  rowData,
  col,
  rowIndex,
  onColumnDataChange,
  headerCheckboxState,
  fieldName,
  handleRowClick,
}) => {

  const [value, setValue] = useState(
    rowData[fieldName] ?? headerCheckboxState
  );

  const isDisabled = !col.colSettings?.allowEdit;

  // checkbox when rowData or header checkbox changes
  useEffect(() => {
    if (rowData[fieldName] !== undefined) {
      setValue(rowData[fieldName]);
    } else {
      setValue(headerCheckboxState);
    }
  }, [rowData[fieldName], headerCheckboxState]);

  const handleCheckboxChange = (e) => {
    const newValue = e.target.checked;

    setValue(newValue);
    handleRowClick?.(e, rowData, rowIndex);

    const updatedData = {
      ...rowData,
      [fieldName]: newValue,
    };

    onColumnDataChange?.(fieldName, updatedData, rowIndex);
  };

  return (
    <GridCheckbox
      type="checkbox"
      checked={value}
      dataField={fieldName}
      // name={`checkbox_${rowIndex}_${fieldName}`}
      onChange={handleCheckboxChange}
      disabled={isDisabled}
    />
  );
};

RenderGridCheckboxColumn.propTypes = {
  rowData: PropTypes.object.isRequired,
  col: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  onColumnDataChange: PropTypes.func.isRequired,
  headerCheckboxState: PropTypes.bool,
  fieldName: PropTypes.string.isRequired,
};

export default RenderGridCheckboxColumn;
